import { render, staticRenderFns } from "./AlertRoot.vue?vue&type=template&id=4321b9ee"
import script from "./AlertRoot.vue?vue&type=script&lang=ts"
export * from "./AlertRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports